import { createContext, useContext } from "react";
import { MenuDataLocale } from "../types/MenuDataLocale";

export const MenuDataLocaleContext = createContext<MenuDataLocale>(null!);

export const useMenuDataLocaleContext = () => useContext(MenuDataLocaleContext);
